import DpMeasuredJournalEvent from "./dp-measured-journal-event";

import { sortBy } from "parog-web/utils/sort";
import BaseDialysisSessionDeclaredModelView, {
  type DialysisMeasured
} from "./dialysis-session-declared-model-view";

/**
 * dp-specific implementation of BaseDialysisSessionDeclaredModelView.
 *
 * This class generates a model used by the Dp::SessionMeasurement view.
 *
 */
export default class DpSessionDeclaredModelView extends BaseDialysisSessionDeclaredModelView<DpMeasuredJournalEvent> {
  protected sessionKey = "dpSessionDeclaredJournalEvent";

  completedArrayWithMissingMeasurements({
    measures,
    moment
  }: {
    measures: DialysisMeasured[];
    moment: string;
  }): DpMeasuredJournalEvent[] {
    const everyMeasurements = [...measures.sort(sortBy("occurredAt"))];

    // Each before/end array should have 1 measurement and
    // cycle array should have 20 measurements
    const expectedCount = moment === "middle" ? 20 : 1;

    const occurredAt = this.session.occurredAt;

    while (everyMeasurements.length < expectedCount) {
      everyMeasurements.push(
        this.store.createRecord("dp-measured-journal-event", {
          moment,
          occurredAt
        })
      );
    }

    return everyMeasurements as DpMeasuredJournalEvent[];
  }

  async validate(): Promise<boolean> {
    await Promise.all([
      ...this.allUsedChangesets.map(changeset => changeset.validate()),
      this.sessionChangeset.validate()
    ]);

    this.validateOccurredAtAgainstPrevious(this.allChangesets);

    return [...this.allUsedChangesets, this.sessionChangeset].every(
      changeset => changeset.isValid
    );
  }

  protected measurementValidations() {
    return DpMeasuredJournalEvent.validations(this.intl);
  }
}
